import { RootState } from '../../../app';

export const selectCompanies = ({ clearbit }: RootState) => clearbit.companies;

export const selectIsLoading = ({ clearbit }: RootState) => clearbit.isLoading;
